/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import Transition from 'components/layout/transition/Transition';
import FilterContainer from 'components/containers/FilterContainer';
import InputFilter from 'components/inputs/InputFilter';
import LateTable from './LateTable';
import Dissatisfied from '@material-ui/icons/SentimentVeryDissatisfied';
import { useStyles } from 'components/layout/CommonStyles';
import { GetGeneralPermissionForAction } from 'utils/permissions/GetGeneralPermissionForAction';

import { Screen, Allow } from 'global/constants';
import { useQueryLSBDLate } from 'hooks/DataFetching/Quotas/Dashboard/useQueryLSBDLate';

import { screenStyles } from '../../Styles';
import { nameSearchFilter } from 'utils/filter/filterFields';

const LateForm = () => {
    const classes = useStyles();
    const styles = screenStyles();
    const [t] = useTranslation();

    const [findText, setFindText] = useState('');
    const [filterName, setFilterName] = useState('');
    const [dataFilter, setDataFilter] = useState([]);

    const [canClick, setCanClick] = useState(false);

    if (localStorage.getItem('auth-token') !== null) {
        var auth = JSON.parse(localStorage.getItem('auth-token'));
    }

    const { isLoading, isFetching, error, data } = useQueryLSBDLate(
        {},
        auth.id
    );

    const hasItens = data && data.length > 0;
    const [hasNoResult, setHasNoResult] = useState(
        hasItens && dataFilter && dataFilter.length === 0
    );

    useEffect(() => {
        if (data) {
            setDataFilter(data.filter(x => !x.hasDeleted));
            setHasNoResult(false);
        }
    }, [data]);

    useEffect(() => {
        if (data && data.length > 0) {
            const { newDataFilter, textNotFound } = applyFilter(
                data.filter(x => !x.hasDeleted)
            );

            if (newDataFilter.length === 0) {
                setDataFilter([]);
                setHasNoResult(true);
                setFindText(textNotFound);
            } else {
                setDataFilter(newDataFilter);
                setHasNoResult(false);
                setFindText('');
            }

            setDataFilter(newDataFilter);
        }
    }, [filterName]);

    const applyFilter = data => {
        let newDataFilter = [];
        let textNotFound = '';

        newDataFilter = data;

        if (filterName) {
            newDataFilter = newDataFilter.filter(item => nameSearchFilter(item.collaboratorName, filterName));

            if (!textNotFound && newDataFilter.length === 0)
                textNotFound = filterName;
        }

        return { newDataFilter, textNotFound };
    };

    useEffect(() => {
        if (filterName) {
            setCanClick(true);
        } else {
            setCanClick(false);
        }
    }, [filterName]);

    return (
        <React.Fragment>
            <Transition loading={isLoading && isFetching} newDesign={true}>
                <FilterContainer>
                    <InputFilter
                        filterValue={filterName}
                        setFilter={setFilterName}
                        label={'GENERAL.collaborator'}
                    />
                </FilterContainer>
                <React.Fragment>
                    <LateTable
                        rows={dataFilter}
                        toFirstPage={canClick}
                        headers={[
                            'id',
                            'collaboratorName',
                            'quantity',
                            'hasAvailableCredit',
                            'value'
                        ]}
                        visibleHeaders={[
                            'Colaborador',
                            'Quantidade',
                            'Possui Crédito',
                            'Valor'
                        ]}
                        sortedFields={[
                            'collaboratorName',
                            'quantity',
                            'hasAvailableCredit',
                            'value'
                        ]}
                        mainField="user"
                    />

                    {!hasItens && !error && (
                        <div className={classes.noDataWrapper}>
                            <h2>{t('QUOTAS.noLSBDLateMessage')}</h2>
                            <h4>{t('QUOTAS.noLSBDLateSubMessage')}</h4>
                        </div>
                    )}
                    {dataFilter.length === 0 && !error && findText && (
                        <div className={classes.noParticipantsMessage}>
                            <div>
                                <Dissatisfied
                                    className={classes.notFoundIconStyle}
                                />
                            </div>
                            <h2>{t('GENERAL.noResultsFound')}</h2>
                            <h5>{`Sua busca por "${findText}" não retornou resultados.`}</h5>
                        </div>
                    )}
                    {error && (
                        <div className={classes.noParticipantsMessage}>
                            <div>
                                <Dissatisfied
                                    className={classes.notFoundIconStyle}
                                />
                            </div>
                            <h2>{'Houve um erro de conexão com o Servidor'}</h2>
                        </div>
                    )}
                </React.Fragment>
            </Transition>
        </React.Fragment>
    );
};

export default LateForm;
